import ibsStore from "../components/Stores/IbsSurveyStore"
import { toNumber } from "../helpers"
import { formatNumber } from "../Helpers/General/FormatHelper";
import { NumberFormat } from "../Enums/constants"
import { mandateToAssetMapping } from "../components/TableComponents/DB/Asset Mandate Table/MandateTableFieldMappings"


export function calculationsForProvided(rawData, props) {
    if (rawData && props.calculationsProvided) {
        props.calculationsProvided.forEach(totalName => {
            //let cellFormat = props.formatting[totalName.calColName];
            rawData.forEach((obj, index) => {
                var valuesArr = []
                totalName.sums.forEach(elem => {
                    valuesArr.push(rawData[index][elem]);
                })
                rawData[index][totalName.calColName] = (typeof totalName.roundFloat === "undefined" || totalName.roundFloat == null || isNaN(parseFloat(calculateTotal(valuesArr))))
                    ? calculateTotal(valuesArr) : parseFloat(calculateTotal(valuesArr)).toFixed(totalName.roundFloat);
            })
        })

    }
    return rawData;
}


export function calculateTotal(values, rowID) {
    let defaultsForRow = ibsStore.defaultCoordinates.filter(def => def.rowID === rowID || def.rowID === "A" + rowID);
    //get the default values to add
    let defaultTotal = 0;
    defaultsForRow.forEach(element => {
        if (element.value != "N/A") defaultTotal = defaultTotal + element.value;
    })
    const total = values
        .filter(val => val !== undefined && val !== null && val !== "" && val !== "N/A")
        .map(val => parseFloat(val))
        .reduce((sum, val) => {
            return sum + val;
        }, 0)
    let finalTotal = total + defaultTotal
    if (finalTotal === 0) finalTotal = ""
    return finalTotal;
}

//Calculation for the total row column
export function columnCalculationDataObj(id, dataObj) {
    var total = 0;
    if (dataObj) {
        dataObj.forEach(row => {
            if (typeof row[id] !== "undefined" && row[id] !== null && row[id] !== "") total = total + parseFloat(row[id]);

            // Sum the children's value if children exist
            let children = row["__children"];
            if (children && children.length && children.length > 0) {
                children.forEach((childObj) => {
                    if (typeof childObj[id] !== "undefined" && childObj[id] !== null && childObj[id] !== "") total = total + parseFloat(childObj[id]);
                });
            }

        })
    }
    let defaultsTotal = 0;
    let fieldID = id
    let defaultsForRow = ibsStore.defaultCoordinates.filter(def => def.qName === fieldID);

    defaultsTotal = defaultsForRow.map((row) => {
        if (row.value == "N/A") row.value = 0
        if (row.value) {
            return parseFloat(toNumber(row.value));
        }
        else {
            return 0;
        }

    }).reduce((sum, val) => {
        return sum + val;
    }, 0)
    total = total + defaultsTotal;
    return total;
}


//Calculation for the total column
export function columnCalculation (id, isTotal = false, props) {
    var total = 0;
    if (ibsStore.allTableResponses[props.tableName]) {
        ibsStore.allTableResponses[props.tableName].forEach(row => {
            if (row[id] !== null && row[id] !== "") total = total + parseFloat(toNumber(row[id])) ?? 0;
        })
    }
    if (isTotal) return total
    total = formatNumber(NumberFormat.MONEYTHOUSAND, total)
    return total
}


export function mandateColumnCalculation(colId, format = null, referenceToTable, dataObj, isInternalStyle){
    let total = 0;
    let testData;

    if (referenceToTable) {
        const initialValueForReduce = 0;
        total = dataObj
            .filter(row => {
                const rowIdString = row?.RowID?.toString();
                if (rowIdString === "")
                    return false;

                if (ibsStore.checkMandateLevel == 1) {
                    // in mandateOnly View
                    // sum all rows that has rowId
                    return true;
                } else {
                    // in "both" View
                    // only sum the rows that has prefix 'A'
                    return rowIdString?.startsWith("A");
                }
            })
            .map((row) => {

                if ((colId == "costInternManage" || colId == "costInternMonitor")) {
                    let actualRow = ibsStore.mandateData.find(mandate => mandate["rowID"] === row["RowID"]);
                    if (actualRow && isInternalStyle(actualRow["styleID"])) {
                        colId = "CostInternManage"
                    }
                    else {
                        colId = "CostInternMonitor"

                    }
                }
                if (colId == "CostInternMonitor") {
                    colId = "CostInternManage"
                }

                let val = row[colId]

                if (val === undefined || val === null || val === "" || val === "N/A" || row.AssetClassCategoryName == 'Total')
                    val = 0;

                return parseFloat(toNumber(val))
            })
            .reduce((sum, val) => {
                return sum + val;
            }, initialValueForReduce)
    }

    //add defaults for this column, only in mandate only view
    if (ibsStore.checkMandateLevel == 1 || ibsStore.checkMandateLevel == 2) {
        let fieldID = colId.charAt(0).toLowerCase() + colId.slice(1);
        let defaultsTotal = 0;
        let mandateToAssetMap = mandateToAssetMapping[colId]
        let defaultsForRow = ibsStore.defaultCoordinates.filter(def => def.qName === fieldID || def.qName == mandateToAssetMap);
        //let rowsShown = dataObj.map((row) => row.RowID).filter((RowID) => (typeof RowID === "number" || RowID.substring(1)=== "number") && !isNaN(RowID))
        let rowsShown = dataObj ? dataObj.map((row) => row.RowID).filter((RowID) => (RowID !== "")): []
        defaultsTotal = defaultsForRow.map((row) => {
            if (row.value == "N/A") row.value = 0
            if (rowsShown.includes(row?.rowID)) {
                return parseFloat(toNumber(row.value));
            }
            else {
                return 0;
            }

        })
            .reduce((sum, val) => {
                return sum + val;
            }, 0)
        total = total + defaultsTotal;
    }


    if (!format) return total
    total = formatNumber(format, total)
    //return parseFloat(toNumber(total));
    return (total)

}


export function checkAllChildrenEmptyForQ (fieldName, children) {
    //if even one child is not null/"" then send back false
    let foundAValue = false;
    children.forEach(child => {
        if (child[fieldName] == null || child[fieldName] == "") {
            //not all children were empty

        } else {
            foundAValue = true
        }
    })
    return foundAValue

}


export function calculateForChildren(children, qID, valueAvailable, rowID, listOfOverrides, listOfCalculated) {
    if (children.length === 0)
        return "" /* TODO what should be returned? zero or NaN or "" */
    let totalChildren = 0.0;
    //special returnPct calculations TODO: make consistent and remove this portion eventually
    if (qID.toLowerCase() === "returnpct" && children) {
        let holdingNavName = "HoldingNavAvg"
        let retPctName = "ReturnPct"
        if (qID == "returnPct") {
            holdingNavName = "holdingNavAvg"
            retPctName = "returnPct"
        }
        let sumProdForChild = 0.0;
        let sumNavAvg = 0.0;
        children.forEach((child) => {
            let childCostHolding = parseFloat(toNumber(child[holdingNavName]))

            if (childCostHolding === undefined || childCostHolding === null || childCostHolding === "" || childCostHolding === "N/A")
                childCostHolding = 0

            let childCostRet = parseFloat(toNumber(child[retPctName]))

            if (childCostRet === undefined || childCostRet === null || childCostRet === "" || childCostRet === "N/A") {
                totalChildren = ""
                return true
            }

            let childCostRetDec = childCostRet / 100
            sumProdForChild = sumProdForChild + (childCostHolding * childCostRetDec)
            sumNavAvg = sumNavAvg + childCostHolding
        })
        if (sumNavAvg && totalChildren !== "") {
            totalChildren = parseFloat(((sumProdForChild / sumNavAvg) * 100).toFixed(2));
        }
    } else if (children) {
        children.forEach((child) => {
            let childCost = child[qID]
            if (childCost === undefined || childCost === null || childCost === "" || childCost === "N/A")
                childCost = 0

            //add any defaults available
            let searchQID = qID.charAt(0).toLowerCase() + qID.slice(1)
            let rowIDdef = child["rowID"]
            if (!rowIDdef) rowIDdef = child["RowID"]
            let defaultsForRow = ibsStore.defaultCoordinates.filter(elem => {
                return (elem.rowID === rowIDdef && searchQID == elem.qName)
            })
            let defaultTotal = 0;
            defaultsForRow.forEach(element => {
                if (element.value != "N/A") defaultTotal = defaultTotal + element.value;
            })

            //total everything up
            totalChildren = totalChildren + parseFloat(childCost) + defaultTotal;

        })
    }
    else if (qID == "notionalAmount") qID = "holdingFeeAvg"
    else if (qID == "derivProfit") qID = "returnPct"
    else if (qID == "costInternMonitor") qID = "CostInternManage"
    else qID = qID.charAt(0).toLowerCase() + qID.slice(1)

    if (valueAvailable) {
        let overrideExists = listOfOverrides.findIndex(elem => elem.qName == qID.charAt(0).toLowerCase() + qID.slice(1) && elem.rowID == "A" + rowID)
        if (overrideExists > -1) {
            listOfOverrides.splice(overrideExists, 1)
        }
        //is an override and not a calculated and there are values for its children, add calc to the list
        if (checkAllChildrenEmptyForQ(qID, children)) {
            listOfOverrides.push({
                "qName": qID,
                "rowID": "A" + rowID,
                "calculated": totalChildren
            })
        }

        return valueAvailable
    } else if (totalChildren !== "" && totalChildren !== 0) {
        let calcExists = listOfCalculated.findIndex(elem => elem.qName == qID.charAt(0).toLowerCase() + qID.slice(1) && elem.rowID == "A" + rowID)
        if (calcExists > -1) {
            listOfCalculated.splice(calcExists, 1)
        }
        listOfCalculated.push({
            "qName": qID,
            "rowID": "A" + rowID,
            "calculated": totalChildren
        })
        return totalChildren
    } else if (totalChildren == 0) {
        //remove from list 
        let calcExists = listOfCalculated.findIndex(elem => elem.qName == qID.charAt(0).toLowerCase() + qID.slice(1) && elem.rowID == "A" + rowID)
        if (calcExists > -1) {
            listOfCalculated.splice(calcExists, 1)
        }
    }
    return totalChildren

}
